// extracted by mini-css-extract-plugin
export var root = "_z9-0";
export var scroll = "_z9-1";
export var thumb = "_z9-3";
export var track = "_z9-2";